
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class TextContent extends Vue {
  @Prop(Object) readonly field?: Record<string, unknown>;
  @Prop(String) readonly label?: string;
}
